import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import ShipheroCredentialsStore from "../../../stores/credentials/shiphero-credentials-store";

interface IIntegrationProps {
    credentialsStore: ShipheroCredentialsStore,
    vGroup: IValidationGroup,
}

const ShipheroCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine label='ShipHero refresh token' required key='refresh_token'>
                <Input
                    value={credentialsStore.refresh_token}
                    onChange={v => credentialsStore.refresh_token = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    )
});

export default ShipheroCredentials;
